import { PageId } from '../../components/Sidebar/Sidebar';
import { UploadPage, UploadType } from '../../components/UploadPage/UploadPage';

const TransactionsUploadPage = () => {
  return (
    <UploadPage
      title="Upload Transaction Data"
      uploadType={UploadType.Transactions}
      pageId={PageId.Transactions}
      showDateRange
    />
  );
};

export default TransactionsUploadPage;
